// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--697f0";
export var item = "Breadcrumbs-module--item--2a92e";
export var link = "Breadcrumbs-module--link--090ff";
export var list = "Breadcrumbs-module--list--b9557";